import React, { useEffect, useRef } from 'react';
import { useDocReader, useDocReaderDispatch } from '../../store/docReaderContext';
import useUpdateDocReaderRenderer from '../../services/useUpdateDocReaderRenderer';
import { RENDER_TYPE } from '../../base';
import { getScaleByWidth } from '../../services/useDocReaderScale';
import classnames from 'classnames';
import { Loading } from 'common/src/components';
import './index.scss';

interface IPropsDocPage {
    pageNum: number;
    visible?: boolean;
}

function DocPage(props: IPropsDocPage) {
    const [state] = useDocReader();
    const { renderType } = state;
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const svgContainerRef = useRef<HTMLDivElement>(null);

    const isRendered = useUpdateDocReaderRenderer({
        svgContainerRef,
        canvasRef,
        pageNum: props.pageNum,
    });

    return (
        <>
            {false && !isRendered && <Loading />}
            <canvas hidden={renderType !== RENDER_TYPE.CANVAS && renderType !== RENDER_TYPE.IMAGE} ref={canvasRef} />

            <div hidden={renderType !== RENDER_TYPE.SVG} className="pdf-svg-container" ref={svgContainerRef}></div>

            {/* <If condition={this.renderType === RENDER_TYPE.IMAGE}>
                            <div className="pdf-image-container" ref={this.imageContainerRef}>
                            </div>
                        </If> */}
        </>
    );
}
function TocPage(props: IPropsDocPage) {
    const [state] = useDocReader();
    const { pdf, renderType } = state;
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const svgContainerRef = useRef<HTMLDivElement>(null);
    const tocContainerRef = useRef<HTMLDivElement>(null);
    const dispatch = useDocReaderDispatch();

    // 初始化时根据父元素宽度，计算出Toc的缩放系数，并设置给tocContainerRef: --scale-factor
    useEffect(() => {
        const tocContainer = tocContainerRef.current;
        if (tocContainer) {
            const parentWidth = tocContainer.parentElement?.clientWidth;
            if (!pdf || !pdf.getPage) {
                return;
            }
            pdf.getPage(props.pageNum).then((page: any) => {
                const scaleFactor = getScaleByWidth(page, Number(parentWidth));
                tocContainer.parentElement?.style.setProperty('--scale-factor', scaleFactor.toString());
            });
        }
    }, [pdf]);

    // 当 state.displayPageNum变化时，tocContainerRef自动滚动进视窗
    // useEffect(() => {
    //     const tocContainer = tocContainerRef.current;
    //     if (tocContainer && props.pageNum === state.displayPageNum) {
    //         tocContainer.scrollIntoView({ block: 'center', behavior: 'smooth' });
    //     }
    // }, [state.displayPageNum, props.pageNum]);

    const isRendered = useUpdateDocReaderRenderer(
        {
            svgContainerRef,
            canvasRef,
            pageNum: props.pageNum,
        },
        {
            once: true,
        },
    );
    return (
        <div
            ref={tocContainerRef}
            className={classnames({
                'toc-container': true,
                'active': props.pageNum === state.displayPageNum,
            })}
            onClick={() => {
                dispatch({ type: 'pageJump', pageNum: props.pageNum });
            }}
        >
            {!isRendered && <Loading />}
            <canvas hidden={renderType !== RENDER_TYPE.CANVAS && renderType !== RENDER_TYPE.IMAGE} ref={canvasRef} />
            <div hidden={renderType !== RENDER_TYPE.SVG} ref={svgContainerRef}></div>
        </div>
    );
}
export { TocPage };

export default DocPage;
